module.exports = __webpack_public_path__ + "static/media/IKCM04.ed936036.jpg";